import { Component, OnInit, EventEmitter, Output, Input, ViewChild, AfterViewInit } from '@angular/core';
import { Usuario } from 'src/app/shared/models/usuario.model';
import DateUtils from 'src/app/shared/utils/date-utils';

@Component({
  selector: 'app-usuario-authentication-form',
  templateUrl: './usuario-authentication-form.component.html',
  styleUrls: ['./usuario-authentication-form.component.scss']
})
export class UsuarioAuthenticationFormComponent implements AfterViewInit {

  usuario: Usuario = new Usuario();

  @Input()
  loading = false;

  @Output()
  login: EventEmitter<Usuario> = new EventEmitter<Usuario>();

  @Output()
  logout: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('inputDataNascimento')
  inputDataNascimento: any;
  
  fieldsWithFocus = [];

  constructor() { }

  ngAfterViewInit(): void {
    if (this.inputDataNascimento) {
      this.inputDataNascimento.control.setValidators([DateUtils.DateValidator]);
    }
  }

  handleLogin(): void {
    this.login.emit(this.usuario);
  }

  handleLogout(): void {
    this.logout.emit();
  }

  setFocus(fieldname: string) {
    this.fieldsWithFocus.push(fieldname);
  }

  removeFocus(fieldname: string) {
    this.fieldsWithFocus = this.fieldsWithFocus.filter((field) => field !== fieldname);
  }

  hasFocus(fieldname: string) {
    return this.fieldsWithFocus.includes(fieldname);
  }

  clearField(control: any, fieldName: string) {
    control.setValue('');
    this.removeFocus(fieldName);
  }
}
